import * as moment from "moment-timezone";
import { ReporteChequeo, ReporteRow } from "../../../../models/ReporteChequeo";
import { calcularTiempoTrabajado } from "../../../../interfaces/formik/IReporteRelojChecador.ts";
import { buildVisitRowsForPartnerBranch } from "../../../../utils/visitPairingReporteChequeo.ts";
import { sortReporteRowsChronologically } from "../../../../utils/reporteChequeoUtils.ts";

export const FormatExcel = (
  records: ReporteChequeo[],
  start: string,
  end: string
): ReporteRow[] => {
  const days = [
    ...new Set(records.map((record) => record.assistanceCheck_checkDate)),
  ];

  const data: ReporteRow[] = [];

  const startDate = new Date(start);
  const endDate = new Date(end);

  for (const day of days) {
    const currentDay = new Date(day); // Convertir cada día a un objeto Date
    const nextDay = new Date(currentDay); // Crear una copia del objeto Date
    nextDay.setDate(currentDay.getDate() + 1); // Sumar un día
    // Comparar si está dentro del rango
    if (currentDay >= startDate && currentDay <= endDate) {
      const checksCurrent = records.filter(
        (record) =>
          record.assistanceCheck_checkDate === currentDay.toISOString()
      );
      const checksNext = records.filter(
        (record) => record.assistanceCheck_checkDate === nextDay.toISOString()
      );
      const partners = [
        ...new Set(checksCurrent.map((record) => record.partner_id)),
      ];

      for (const partner of partners) {
        // Obtener las sucursales donde han checado, la propiedad es branch_id
        const branchesCurrent = checksCurrent
          .filter((record) => record.partner_id === partner)
          .map((record) => record.branch_id);

        const branchesNext = checksNext
          .filter((record) => record.partner_id === partner)
          .map((record) => record.branch_id);

        // Combinar ambas listas y eliminar duplicados usando Set
        const branches = [...new Set([...branchesCurrent, ...branchesNext])];

        // Iterar sobre cada sucursal
        for (const branch of branches) {
          const checkCurrent = checksCurrent
            .filter(
              (record) =>
                record.partner_id === partner && record.branch_id === branch
            )
            .sort((a, b) =>
              a.assistanceCheck_checkTime.localeCompare(
                b.assistanceCheck_checkTime
              )
            ); // Ordenar por hora ascendente

          const checkNext = checksNext
            .filter(
              (record) =>
                record.partner_id === partner && record.branch_id === branch
            )
            .sort((a, b) =>
              a.assistanceCheck_checkTime.localeCompare(
                b.assistanceCheck_checkTime
              )
            ); // Ordenar por hora ascendente

          const visitRows = buildVisitRowsForPartnerBranch(
            checkCurrent,
            checkNext,
            branch,
            partner,
            checksCurrent,
            checksNext
          );
          for (const row of visitRows) {
            data.push(row);
          }
        }
      }
    }
  }

  return sortReporteRowsChronologically(data);
};

export const SumByDay = (
  index: number,
  records: ReporteRow[]
): { isLast: boolean; totalHours: number; title: string } => {
  let totalHours = 0;
  const currentDate = records[index]?.checkIn?.assistanceCheck_checkDate;
  if (!currentDate) return { isLast: false, totalHours: 0, title: "" };
  const tomorrowDate = records[index + 1]?.checkIn?.assistanceCheck_checkDate;

  const isLast = Boolean(
    currentDate &&
      (!tomorrowDate || !moment(currentDate).isSame(tomorrowDate, "day"))
  );

  totalHours = records
    .filter(
      (record) => record.checkIn?.assistanceCheck_checkDate === currentDate
    )
    .reduce((acc, record) => {
      const time = calcularTiempoTrabajado(
        record.checkIn?.assistanceCheck_checkTime!,
        record.checkOut?.assistanceCheck_checkTime
      );
      return acc + Number(time) || 0;
    }, 0);

  const title = `Horas totales ${moment
    .utc(currentDate)
    .format("[del] D MMMM YYYY")}`;

  return { totalHours, isLast, title };
};

export const totalHours = (records: ReporteRow[]): number => {
  return records.reduce((acc, record) => {
    const time = calcularTiempoTrabajado(
      record.checkIn?.assistanceCheck_checkTime!,
      record.checkOut?.assistanceCheck_checkTime
    );
    return acc + Number(time) || 0;
  }, 0);
};
